import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  SelectChangeEvent,
  TextField,
  Tooltip,
} from "@mui/material";
import LogDataset from "../../../components/data/LogDataset";
import Log from "../../../components/classes/Log";
import Usuario from "../../../components/classes/Usuario";
/*
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import br from "date-fns/locale/pt-BR";
import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
*/
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers'
import br from "date-fns/locale/pt-BR";
import HistoricoPedidoImportacao from "../../../components/classes/HistoricoImportacao";
import HistoricoPedidoImportacaoDataset from "../../../components/data/HistoricoImportacaoDataSet";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
// import { Data } from "react-csv/components/CommonPropTypes";
import CustomToolbarHistoricoPedidoImportacao from "./customToolbar";
import { Download } from "@mui/icons-material";
import DownloadCSVModal from "../../../components/common/DownloadCSVModal/DownloadCSVModal";

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function HistoricoPedidoImportacaoModalDetalhe(
  props: HistoricoPedidoImportacaoModalDetalhePropsTypes
) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [historicosImportacao, setHistoricosImportacao] = useState<
    HistoricoPedidoImportacao[]
  >([]);
  const [rows, setRows] = useState<Data>([]);
  const columns: GridColumns = createColumns();

  const [openDownloadCSVModal, setOpenDownloadCSVModal] =
    useState<boolean>(false);

  const historicoPedidoImportacaoDataset: HistoricoPedidoImportacaoDataset =
    new HistoricoPedidoImportacaoDataset();

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    historicoPedidoImportacaoDataset
      .getAll()
      .then((result) => {
        fillTable(result);
        setHistoricosImportacao(result);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function createColumns(): GridColumns {
    let cols: GridColumns = [
      {
        field: "id",
        headerName: t("common.id"),
        width: 80,
        align: "center",
        headerAlign: "center",
        renderHeader: (item) => {
          return <div>#</div>;
        },
      },
      {
        field: "dataEvento",
        headerName: t("pages.importRequest.text.eventDate"),
        type: "date",
        width: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
        valueFormatter: (item) => {
          return new Date(item.value).toLocaleString("pt-BR");
        },
      },
      {
        field: "idPedidoImportacao",
        headerName: t("pages.importRequest.text.orderImportId"),
        type: "string",
        width: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "dataRemessa",
        headerName: t("pages.importRequest.text.shippingDate"),
        type: "date",
        width: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
        valueFormatter: (item) => {
          return new Date(item.value).toLocaleDateString("pt-BR");
        },
      },
      {
        field: "quem",
        headerName: t("pages.importRequest.text.responsible"),
        type: "string",
        width: 300,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
    ];
    return cols;
  }

  function fillTable(historicosImportacaoArr: HistoricoPedidoImportacao[]) {
    let gridData: Data = [];
    historicosImportacaoArr.forEach((item: HistoricoPedidoImportacao) => {
      let json = JSON.parse(HistoricoPedidoImportacao.toJson(item));
      let objetoPedido = JSON.parse(json.objeto.replace(/\|.*$/g, ""));
      json.idPedidoImportacao = objetoPedido.Id;
      json.dataRemessa = new Date(objetoPedido.DataRemessa);
      json.dataEvento = new Date(
        new Date(json.dataEvento).setHours(
          new Date(json.dataEvento).getHours() - 3
        )
      );
      gridData.push(json);
    });
    setRows(gridData);
  }

  const handleClickOpenDownloadCSV = () => {
    setOpenDownloadCSVModal(true);
  };

  function handleCloseDownloadCSVModal() {
    setOpenDownloadCSVModal(false);
  }

  return (
    <>
      <div className="containerToolbar">
        <Tooltip title={t("pages.importRequest.text.csvDownload2")}>
          <span>
            <IconButton
              onClick={handleClickOpenDownloadCSV}
              disabled={isLoading}
            >
              <Download />
            </IconButton>
          </span>
        </Tooltip>
      </div>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
        <Box
          display={"flex"}
          height={"50vh"}
          width={"100%"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <DataGrid
            loading={isLoading}
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[50, 100, 250, 500]}
          />
        </Box>
      </LocalizationProvider>
      <Modal
        open={openDownloadCSVModal}
        onClose={handleCloseDownloadCSVModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <DownloadCSVModal
          handleClose={handleCloseDownloadCSVModal}
          rows={rows}
          columns={columns}
          name={`Histórico de Pedido de Importação`}
        />
      </Modal>
    </>
  );
}

interface HistoricoPedidoImportacaoModalDetalhePropsTypes {
  handleClose: any;
}
